// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----News-module---container---2EAhk","bar":"src-components----News-module---bar---3d2M2","badge":"src-components----News-module---badge---qE09B","chevron":"src-components----News-module---chevron---3zXH0","inline":"src-components----News-module---inline---1GxdQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/News.module.css
// module id = 129
// module chunks = 35783957827783 43201937662106